<template>
  <div class="d-flex-row">
    <div
      class="d-flex-row gap-5 flex-wrap"
      style="max-width: 100px"
      v-if="orderDetails?.achievements?.length > 0"
    >
      <template
        v-for="achievement in orderDetails?.achievements"
        :key="achievement"
      >
        <img
          :src="achievement.icon"
          alt="Achievement icon"
          height="20"
          width="20"
          v-if="achievement.icon"
        />
        <p class="t-white font-family-2 regular-m" v-else>
          {{ achievement.title }}
        </p>
      </template>

      <!-- <p class="t-white">{{ orderDetails }}</p> -->
    </div>
    <div
      class="d-flex-column justify-start align-start gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.gadgetsAndWeapons?.length > 0"
    >
      <!-- <img

                :src="achievement.icon"
                height="20"
                width="20"
            /> -->
      <label
        class="t-grey d-flex-row flex-8 justify-start align-start font-family-2 regular-l"
        v-for="achievement in orderDetails?.gadgetsAndWeapons"
        style="text-align: start"
        :key="achievement"
      >
        {{ achievement.title }}
      </label>
      <!-- <p class="t-white">{{ orderDetails }}</p> -->
    </div>

    <div
      class="d-flex-column justify-start align-start gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.weapons?.length > 0"
    >
      <label
        class="t-grey d-flex-row flex-8 justify-start align-start font-family-2 regular-l"
        v-for="achievement in orderDetails?.weapons"
        style="text-align: start"
        :key="achievement"
      >
        {{ achievement.weapon_title }}
        <span v-if="achievement.category_title"
          >- {{ achievement.category_title }}</span
        >
      </label>
    </div>

    <div
      class="d-flex-column justify-start align-start gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.camoSpecial?.id"
    >
      <label
        class="t-grey d-flex-row flex-8 justify-start align-start font-family-2 regular-l"
      >
        {{ $t(orderDetails?.camoSpecial?.title) }}
      </label>
    </div>
    <div
      class="d-flex-column justify-start align-start gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.nukeItems?.length > 0"
    >
      <label
        class="t-grey d-flex-row flex-8 font-family-2 regular-l"
        v-for="achievement in orderDetails?.nukeItems"
        style="text-align: start"
        :key="achievement"
      >
        {{ achievement.title }}
      </label>
    </div>
    <div
      class="d-flex-column justify-start align-start gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.reticleItems?.length > 0"
    >
      <label
        class="t-grey d-flex-row flex-8 font-family-2 regular-l"
        v-for="achievement in orderDetails?.reticleItems"
        style="text-align: start"
        :key="achievement"
      >
        {{ achievement.title }}
      </label>
    </div>
    <!-- CURRENT RANK / DESIRED RANK -->
    <img
      :src="orderDetails?.rank.image_dark"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.rank"
    />
    <img
      :src="orderDetails?.currentRank.image_dark"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.currentRank?.image_dark"
    />
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="
        orderDetails?.currentRank?.image_dark &&
        orderDetails?.desiredRank?.image_dark
      "
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>

    <img
      :src="orderDetails?.desiredRank?.image_dark"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.desiredRank?.image_dark"
    />

    <label
      class="t-white font-family-1 title-h6"
      v-if="!orderDetails.currentRank && orderDetails?.currentRankPoints"
    >
      {{ orderDetails.currentRankPoints }}
    </label>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="
        orderDetails?.currentRankPoints &&
        orderDetails?.desiredRankPoints &&
        !orderDetails.currentRank &&
        !orderDetails.desiredRank
      "
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>
    <label
      class="t-white font-family-1 title-h6"
      v-if="!orderDetails.desiredRank && orderDetails?.desiredRankPoints"
    >
      {{ orderDetails.desiredRankPoints }}
    </label>

    <!-- PRESTIGE -->
    <label
      class="t-white font-family-1 title-h6 d-flex-column flex-3 gap-0"
      v-if="orderDetails.currentPrestige && orderDetails?.currentPrestigeLevel"
    >
      <span class="t-light font-family-2 regular-s">{{
        orderDetails.currentPrestige?.title
      }}</span>
      {{ orderDetails.currentPrestigeLevel }}
    </label>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="orderDetails?.currentPrestige && orderDetails?.desiredPrestige"
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>
    <label
      class="t-white font-family-1 title-h6 d-flex-column flex-3 gap-0"
      v-if="orderDetails.desiredPrestige && orderDetails?.desiredPrestigeLevel"
    >
      <span class="t-light font-family-2 regular-s">{{
        orderDetails.desiredPrestige?.title
      }}</span>
      {{ orderDetails.desiredPrestigeLevel }}
    </label>
    <!-- SOUL FIGHTER -->
    <img
      :src="orderDetails?.soulFighterRank.icon"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.soulFighterRank"
    />

    <!-- CURRENT TIER / DESIRED TIER -->

    <img
      :src="orderDetails?.currentTier.icon"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.currentTier"
    />
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="orderDetails?.currentTier && orderDetails?.desiredTier"
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>

    <img
      :src="orderDetails?.desiredTier?.icon"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.desiredTier"
    />

    <!-- CURRENT FACEIT DIVISION / DESIRED FACEIT DIVISION -->

    <img
      :src="orderDetails?.faceitCurrentDivision.icon"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.faceitCurrentDivision"
    />
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="
        orderDetails?.faceitCurrentDivision &&
        orderDetails?.faceitDesiredDivision
      "
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>

    <img
      :src="orderDetails?.faceitDesiredDivision?.icon"
      alt="Game rank icon"
      height="24"
      width="24"
      v-if="orderDetails?.faceitDesiredDivision"
    />

    <!-- NUMBER OF GAMES / NUMBER OF WINS -->
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfGames"
    >
      <h6 class="image_darktitle-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfGames }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.games")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfWins"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfWins }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.wins")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfRounds"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfRounds }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.numberOfRounds")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.currentMmr"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.currentMmr }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.currentMmr")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.desiredMmr"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.desiredMmr }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.desiredMmr")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfHours"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfHours }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.hours")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.vodReviews"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.vodReviews }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.reviews")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.conquestPoints"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.conquestPoints }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.conquestPoints")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.honor"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.honor }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.honor")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.gold"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.gold }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.gold")
      }}</label>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfRuns"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfRuns }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.numberOfRuns")
      }}</label>
    </div>

    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfGalacticGuns"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfGalacticGuns }}
      </h6>
      <label class="t-white regular-s font-family-2">
        {{ $t("calculators_common.number_of_galactic_guns") }}
      </label>
    </div>
    <div
      class="d-flex-row gap-5"
      style="max-width: max-content"
      v-if="orderDetails?.currentDrive >= 0 && orderDetails?.desiredDrive"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.currentDrive }}
      </h6>
      <DoubleRight />
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.desiredDrive }}
      </h6>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfOrbs"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        x{{ orderDetails?.numberOfOrbs }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        orderDetails?.orbId
      }}</label>
    </div>

    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.gearId"
    >
      <label class="t-white regular-s font-family-2">{{
        $t("path_of_exile.gear_type")
      }}</label>
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.gearId }}
      </h6>
    </div>

    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.numberOfRivalPoints"
    >
      <label class="t-white regular-s font-family-2">{{
        $t("fc-boost.rival_points")
      }}</label>
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.numberOfRivalPoints }}
      </h6>
    </div>

    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.trials"
    >
      <label class="t-white regular-s font-family-2">{{
        $t("path_of_exile.trials2")
      }}</label>
      <h6
        class="title-h6 f-w-500 t-white font-family-1"
        v-for="trial in orderDetails.trials"
        :key="trial"
      >
        {{ trial }}
      </h6>
    </div>

    <div class="d-flex-column gap-0" v-if="orderDetails?.coins">
      <p class="t-grey font-family-2 regular-l">
        {{ $t("main.nav.coins") }}
      </p>
      <p class="t-white font-family-2 bold-l">{{ orderDetails?.coins }}</p>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.optionSlabs?.length > 0"
    >
      <label class="t-white regular-s font-family-2">{{
        $t("fc-boost.divisions")
      }}</label>
      <h6
        class="title-h6 f-w-500 t-white font-family-1"
        v-for="trial in orderDetails.optionSlabs"
        :key="trial"
      >
        {{ trial }}
      </h6>
    </div>

    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.acts"
    >
      <label class="t-white regular-s font-family-2">{{
        $t("path_of_exile.campaign_acts")
      }}</label>
      <h6
        class="title-h6 f-w-500 t-white font-family-1"
        v-for="trial in orderDetails.acts"
        :key="trial"
      >
        {{ trial }}
      </h6>
    </div>
    <div
      class="d-flex-column gap-0"
      style="max-width: max-content"
      v-if="orderDetails?.raidDifficulty"
    >
      <h6 class="title-h6 f-w-500 t-white font-family-1">
        {{ orderDetails?.raidDifficulty }}
      </h6>
      <label class="t-white regular-s font-family-2">{{
        $t("order.card.raidDifficulty")
      }}</label>
    </div>

    <h6
      class="title-h6 f-w-500 t-white font-family-1"
      v-if="orderDetails?.currentLvl"
    >
      {{ orderDetails?.currentLvl }}
    </h6>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="orderDetails?.currentLvl && orderDetails?.desiredLvl"
    >
      <path
        d="M3.73438 1.63428L5.34976 1.63428L10.7344 7.23428L5.34976 12.8343H3.73438"
        stroke="#45494D"
      />
      <path
        d="M3.73438 4.43359H4.48822L7.00104 7.23359L4.48822 10.0336H3.73438"
        stroke="#45494D"
      />
    </svg>

    <h6
      class="title-h6 f-w-500 t-white font-family-1"
      v-if="orderDetails?.desiredLvl"
    >
      {{ orderDetails?.desiredLvl }}
    </h6>
  </div>
</template>

<script>
import DoubleRight from "~/components/icons/DoubleRight.vue";
export default {
  data() {
    return {};
  },
  props: {
    orderDetails: {
      default: null,
    },
  },
  components: {
    DoubleRight,
  },
};
</script>
